/* 函数式(Functional Programming) 
   参考Ramda.js https://ramda.cn/
   待增加不完全函数、管道函数
*/
const fn = {
    // curry :: (a -> b) -> a -> b
    curry: function (fn) {
        return (function func(params, len) {
            return function() {
                const args = [].slice.apply(arguments);
                const l = args.length;
                if (l >= len) {
                    return fn.apply(null, params.concat(args));
                } else {
                    return func(params.concat(args), len - l);
                }
            }
        })([], fn.length);
    },
    // compose :: (b -> c, a -> b) -> a -> c
    // compose(f1, f2, f3)(p) => f1(f2(f3(p)))
    compose: function () {
        return [].reduce.call(arguments, function(acc, f) {
            return function(p) {
                return acc(f(p));
            };
        });
    },
    // identity :: i -> i
    identity: i => i,
};

const List = {
    // join :: String -> [a] -> String
    // join(';', [1, 2]) => '1;2'
    join: fn.curry((s, list) => list.join(s)),

    // map :: (a -> b) -> [a] -> [b]
    map: fn.curry((fn, list) => list.map(fn)),

    // filter :: (a -> a) -> [a] -> [a]
    filter: fn.curry((fn, list) => list.filter(fn)),

    // reduce :: ((a, b) -> a) -> a -> [b] -> a
    reduce: fn.curry((fn, acc, list) => list.reduce(fn, acc)),

    // insert :: Number -> [] -> [val]
    // fn.insert(1, 'b', ['a', 'c']) => ['a', 'b', 'c']
    insert: fn.curry((idx, elt, list) => {
        idx = idx < list.length && idx >= 0 ? idx : list.length;
        var result = Array.prototype.slice.call(list, 0);
        result.splice(idx, 0, elt);
        return result;
    }),

    // append :: val -> [] -> [val]
    // fn.append('b', ['a']) => ['a', 'b']
    append: fn.curry((val, list) => {
        var result = Array.prototype.slice.call(list, 0);
        result.push(val);
        return result;
    }),

    // find :: (a → Boolean) → [a] → a | undefined 
    find: fn.curry((fn, list) => list.find(fn)),
};

const Obj = {
    // prop :: String → {s: a} → a | undefined 
    prop: fn.curry((s, obj) => obj[s]),
};

const Relation = {
    // propEq :: String → a → Object → Boolean
    propEq: fn.curry((props, value, obj) => obj[props] === value),

    // contains :: a -> [a, b] -> Boolean
    contains: fn.curry((a, list) => list.indexOf(a) > -1),
};

const Other = {
    // defValue :: a → b → a|b
    // fp.defValue({}, undefined) => {}
    defValue: fn.curry((defVal, val) => val == undefined ? defVal : val),

    // split :: String -> String → List
    // fp.split(',', 'a,b') => ['a', 'b']
    split: fn.curry((separator, str) => {
        return str.split(separator);
    }),
}

export default { ...fn, ...List, ...Obj, ...Relation, ...Other };


// WEBPACK FOOTER //
// ./src/utils/fp.js